import React, { Component } from "react";
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import Pagination from 'react-bootstrap/Pagination';
import { deregisterAdminAction } from 'actions/adminActions';
import { fetchAllAdminAction } from 'actions/adminActions';
import { fetchDistrictAction } from 'actions/localityActions';
import HomeNav from "components/Navbars/HomeNav.js";
import HomePageHeader from "components/Headers/HomePageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";

// reactstrap components
import {
  Card,
  Container,
  CardBody,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Select from 'react-select';

class AdminDeletePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstFocus: false,
      lastFocus: false,
      country: '',
      stateLocation: '',
      selectedDistrict: [],
      districtOptions: [],
      resultSize: 5,
      sortOrder: 'ASC'
    }
    this.stateFilterChanged = this.stateFilterChanged.bind(this);
    this.handleDistrictChange = this.handleDistrictChange.bind(this);
    this.handleDeleteAdmin = this.handleDeleteAdmin.bind(this);
    this.constructPaginationLinks = this.constructPaginationLinks.bind(this);
    this.pageChanged = this.pageChanged.bind(this);
    this.sizeChanged = this.sizeChanged.bind(this);
    this.sortChanged = this.sortChanged.bind(this);
    this.isHideDeleteButton = this.isHideDeleteButton.bind(this);
  }

  componentWillMount() {
    document.title = 'Delete Administrator';
    let districts = [];
    if (!this.props.response.login.isSignedIn) {
      //user not logged in..redirect to login page
      this.props.response.login.redirectAfterSignInTo = '/liquidlove/delete-admin';
    }
    else{
      this.state.country = this.props.response.login.adminCountry;
      this.state.stateLocation = this.props.response.login.adminStateLocation;
    }

    const districtPayload = {
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      token: this.props.response.login.userToken,
    };

    const adminPayload = { 
      pageNum: 0,
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      districts: districts,
      sortOrder: this.state.sortOrder,
      token: this.props.response.login.userToken
    }
    if(this.props.response.login.isSuperAdmin ||
      this.props.response.login.isStateAdmin){
      this.props.dispatch(fetchDistrictAction(districtPayload));
      this.props.dispatch(fetchAllAdminAction(adminPayload));
    }
  }

  componentWillUnmount() {
    if(this.props.response.admin.deregister !== 'undefined')
      delete this.props.response.admin.deregister;

    if(this.props.response.admin.adminList !== 'undefined')
      delete this.props.response.admin.adminList;
    
    if(this.props.response.locality.response !== 'undefined')
      delete this.props.response.locality.response;
      
    this.state.districtOptions = [];
    this.state.selectedDistrict = [];  
  }

  isHideDeleteButton(row){     
    let isSuperAdminRole = false;
    row.roles.map((item) => {
      if(item.name == "ROLE_SUPER_ADMIN")
      isSuperAdminRole = true;
    })

    let isAdminRow = this.props.response.login.adminName == row.username ? true : false;

    if(isAdminRow || (isSuperAdminRole && !this.props.response.login.isSuperAdmin))
      return true;
    else
      return false;
  }

  stateFilterChanged(e){
    this.state.stateLocation = e.target.text;
    this.state.selectedDistrict = [];
    const districtPayload = {
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      token: this.props.response.login.userToken,
    };
     
    let districts = [];
    this.state.selectedDistrict.map((district) => {
        districts.push(district.value);
    })
    const adminPayload = { 
      pageNum: 0,
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      districts: districts,
      sortOrder: this.state.sortOrder,
      token: this.props.response.login.userToken
    }

    if (this.props.response.login.isSuperAdmin ||
      this.props.response.login.isStateAdmin) {
        if(this.props.response.admin.deregister !== 'undefined')
            delete this.props.response.admin.deregister;   
        
        this.props.dispatch(fetchDistrictAction(districtPayload));
        this.props.dispatch(fetchAllAdminAction(adminPayload));
    }
  }

  handleDistrictChange = (selectedDistrict) => {    
    this.setState({ selectedDistrict });
    let districts = [];
    selectedDistrict.map((district) => {
        districts.push(district.value);
    })

    const adminPayload = { 
      pageNum: 0,
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      districts: districts,
      sortOrder: this.state.sortOrder,
      token: this.props.response.login.userToken
    }
    if (this.props.response.login.isSuperAdmin ||
      this.props.response.login.isStateAdmin) {   
        if(this.props.response.admin.deregister !== 'undefined')
          delete this.props.response.admin.deregister;
        this.props.dispatch(fetchAllAdminAction(adminPayload));
    }
  };
  
  constructPaginationLinks(totalPages,currentPage) {
    let items = [];
    if (totalPages === 1 || totalPages === 0) {
      return items;
    }

    if (totalPages > 10) {      
      if (currentPage > 0) {
        items.push(
          <Pagination.Item key={1}>{1}</Pagination.Item>
        );
        if(currentPage != 1){
          items.push(
            <Pagination.Ellipsis />
          );
          items.push(
            <Pagination.Item key={currentPage}>{currentPage}</Pagination.Item> 
          );
        }
      }
      //Current page
      items.push(
        <Pagination.Item key={currentPage +1} active>
          {currentPage +1}
        </Pagination.Item> 
      );

      if (currentPage < totalPages -1) {
        items.push(
          <Pagination.Item key={currentPage +2}>{currentPage +2}</Pagination.Item>
        );
        if(currentPage < totalPages -2){
          items.push(
            <Pagination.Ellipsis />
          );
          items.push(
            <Pagination.Item key={totalPages}>{totalPages}</Pagination.Item>
          );
        }
      }      
      return items;
    }
    
    for (let number = 0; number < totalPages; number++) {
      let index = number + 1;

      items.push(
        <Pagination.Item key={index} active={index === (currentPage) + 1}>
          {index}
        </Pagination.Item>
      );
    }
    return items;
  }

  pageChanged(e) {
    if(e.target.text === undefined)
      return;
    
    let index = e.target.text;
    let districts = [];
    this.state.selectedDistrict.map((district) => {
        districts.push(district.value);
    })
    
    const adminPayload = { 
      pageNum: parseInt(index -1),
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      districts: districts,
      sortOrder: this.state.sortOrder,
      token: this.props.response.login.userToken
    }
    if (this.props.response.login.isSuperAdmin ||
      this.props.response.login.isStateAdmin) {   
        if(this.props.response.admin.deregister !== 'undefined')
          delete this.props.response.admin.deregister;
        
        this.props.dispatch(fetchAllAdminAction(adminPayload));
    }
  }

  sizeChanged(e){
    this.state.resultSize = parseInt(e.target.text);
    let districts = [];
    this.state.selectedDistrict.map((district) => {
        districts.push(district.value);
    })
    
    const adminPayload = { 
      pageNum: 0,
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      districts: districts,
      sortOrder: this.state.sortOrder,
      token: this.props.response.login.userToken
    }
    if (this.props.response.login.isSuperAdmin ||
      this.props.response.login.isStateAdmin) {   
        if(this.props.response.admin.deregister !== 'undefined')
          delete this.props.response.admin.deregister;
        this.props.dispatch(fetchAllAdminAction(adminPayload));
    }
  }

  sortChanged(sortOrder){
    if(this.state.sortOrder === sortOrder) //if sort order is already same as requested sort order, do nothing
      return;

    this.state.sortOrder = sortOrder;
    let districts = [];
    this.state.selectedDistrict.map((district) => {
        districts.push(district.value);
    })
    
    const adminPayload = { 
      pageNum: 0,
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      districts: districts,
      sortOrder: this.state.sortOrder,
      token: this.props.response.login.userToken
    }
    if (this.props.response.login.isSuperAdmin ||
      this.props.response.login.isStateAdmin) {   
      if(this.props.response.admin.deregister !== 'undefined')
        delete this.props.response.admin.deregister;
      this.props.dispatch(fetchAllAdminAction(adminPayload));
    }
  }

  handleDeleteAdmin(row) {
    if(this.isHideDeleteButton(row))
      return;

    let districts = [];
    this.state.selectedDistrict.map((district) => {
        districts.push(district.value);
    })
    const deletePayload = { 
      adminId: row.id,
      fetchAdminRequest: { 
        pageNum: 0,
        size: this.state.resultSize,
        country: this.state.country,
        stateLocation: this.state.stateLocation,
        districts: districts,
        sortOrder: this.state.sortOrder
      },
      token: this.props.response.login.userToken
    }
    if (this.props.response.login.isSuperAdmin ||
      this.props.response.login.isStateAdmin) {   
      this.props.dispatch(deregisterAdminAction(deletePayload));
    }
  }

  render() {
    if (!this.props.response.login.isSignedIn) {
      return <Navigate to={'/liquidlove/login'} />
    }

    let message;
    let totalPages = 0;
    let currentPage = 0;
    
    this.state.districtOptions = [];
    if(this.props.response.locality.response && this.props.response.locality.response.districts){
      this.props.response.locality.response.districts.map((district) => {
        let districtItem = {value: '', label: ''};
        districtItem.value = district;
        districtItem.label = district;
        this.state.districtOptions.push(districtItem);
      })
    }  

    const { selectedDistrict } = this.state;

    if(this.props.response.admin &&
      this.props.response.admin.hasOwnProperty('adminList') &&
      this.props.response.admin.adminList !== undefined){
      if(this.props.response.admin.adminList.hasOwnProperty('error')){
        if(this.props.response.admin.adminList.status === 401){
          message = 'Your session has expired. Please login again'
        }
        else
          message = 'Sairam! Sorry. We are not able to process your request.'
      }
      else{
        totalPages = this.props.response.admin.adminList.totalPages;
        currentPage = this.props.response.admin.adminList.number;
      }  
    }

    if(!(this.props.response.login.isSuperAdmin || this.props.response.login.isStateAdmin)){
      message =  'Sairam! You dont have access to delete an admin';
    }
    else if (this.props.response.admin.hasOwnProperty('deregister')){
      this.props.response.admin.adminList = this.props.response.admin.deregister.users;
      totalPages = this.props.response.admin.adminList.totalPages;
      currentPage = this.props.response.admin.adminList.number;
      if(this.props.response.admin.deregister.hasOwnProperty('status'))
        if(this.props.response.admin.deregister.status === 'success')
          message = 'Sairam! administrator is deleted';
        else if(this.props.response.admin.deregister.status === 'error'){
          this.props.response.admin.deregister.message ?
            message = this.props.response.admin.deregister.message :
            message = 'Sairam! Administrator is NOT deleted';
        }
    }
    
    return (            
          <div className="wrapper">
            <HomePageHeader /><HomeNav adminName={this.props.response.login.adminName}/>
            <div  className="section section-signup"
              style={{
                backgroundImage: "url(" + require("assets/img/shivaratri-wallpapers-6.png") + ")",
                backgroundSize: "cover",
                backgroundPosition: "top center",
                minHeight: "700px",
              }}
            >
              <Container>
              <Card>
                <CardBody align="center" tag="h6">Administrators</CardBody>
              </Card>
              <UncontrolledDropdown disabled={!this.props.response.login.isSuperAdmin}  className="btn-group" size="sm">
                  <DropdownToggle
                    aria-expanded={false}
                    aria-haspopup={true}
                    caret
                    color="primary"
                    data-toggle="dropdown"
                    type="button"
                  >
                    State
                  </DropdownToggle>
                  <DropdownMenu style={{overflowY: 'scroll', maxHeight: "300px" }}>                    
                  {this.props.response.locality.response && this.props.response.locality.response.stateLocations ? 
                    this.props.response.locality.response.stateLocations.map((stateLocation) => (
                    <DropdownItem active={this.state.stateLocation === stateLocation} href={stateLocation} onClick={e => {e.preventDefault(); this.stateFilterChanged(e)}}>{stateLocation}</DropdownItem>
                    )) : ''}
                  </DropdownMenu>
              </UncontrolledDropdown>&nbsp;&nbsp;
              <div style={{color: "white"}}>{this.state.stateLocation}</div><br/>
              <div style={{color: "white"}}>Select districts</div>
              <Select
                className="btn-group" size="md"
                value={selectedDistrict}
                onChange={this.handleDistrictChange}
                options={this.state.districtOptions}
                isMulti
              />
           <UncontrolledDropdown className="btn-group" size="sm">
                <DropdownToggle
                  aria-expanded={false}
                  aria-haspopup={true}
                  caret
                  color="primary"
                  data-toggle="dropdown"
                  type="button"
                >
                  Size
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem  href="5" onClick={e => {e.preventDefault(); this.sizeChanged(e)}}>5</DropdownItem>
                  <DropdownItem  href="10" onClick={e => {e.preventDefault(); this.sizeChanged(e)}}>10</DropdownItem>
                  <DropdownItem  href="15" onClick={e => {e.preventDefault(); this.sizeChanged(e)}}>15</DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
            <div style={{color: "white"}}>{message}</div>
            <TableContainer component={Paper}>
                <Pagination size="sm" onClick={(event) => this.pageChanged(event)} >
                  {this.constructPaginationLinks(totalPages,currentPage)}
                </Pagination>
                <Table className="table" size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">
                        <i onClick={() => this.sortChanged('ASC')} className="now-ui-icons arrows-1_minimal-up mr-1"></i>
                        <i onClick={() => this.sortChanged('DESC')} className="now-ui-icons arrows-1_minimal-down mr-1"></i>
                        User name
                      </TableCell>
                      <TableCell align="left">email</TableCell>
                      <TableCell align="left">Phone</TableCell>                      
                      <TableCell align="left">Roles</TableCell>
                      <TableCell align="left">State</TableCell>
                      <TableCell align="left">District</TableCell>
                      <TableCell align="left"><i className="now-ui-icons ui-1_simple-remove mr-1"></i></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  {this.props.response.admin.adminList && this.props.response.admin.adminList.content ? this.props.response.admin.adminList.content.map((row) => (
                      <TableRow key={row.id} >
                        <TableCell align="left">{row.username}</TableCell>
                        <TableCell align="left">{row.email}</TableCell>
                        <TableCell align="left">{row.phone}</TableCell>                        
                        <TableCell align="left">{row.roles ? row.roles.map((role) => (role.name + " | ")) : 'None'}</TableCell>
                        <TableCell align="left">{row.stateLocation}</TableCell>
                        <TableCell align="left">{row.district}</TableCell>
                        <TableCell align="left" onClick={() => this.handleDeleteAdmin(row)}>
                          {this.isHideDeleteButton(row) ? '' :
                            <i className="now-ui-icons ui-1_simple-remove mr-1"></i>
                          }
                        </TableCell>
                      </TableRow>
                    )) : ''}
                  </TableBody>
                </Table>
                <Pagination size="sm" onClick={(event) => this.pageChanged(event)} >
                  {this.constructPaginationLinks(totalPages,currentPage)}
                </Pagination>                
              </TableContainer>
            </Container>                
          </div>
          <DefaultFooter />
        </div>
        )}
};

const mapStateToProps = (response) => ({response});

export default connect(mapStateToProps)(AdminDeletePage);